<template>
  <div>
<!--   
    <el-row type="flex"  justify="center">
      <el-col :span="24">
        <h1>Indicadores NBRtec</h1>
      </el-col>
    </el-row>
     -->
    <el-row type="flex" v-if="permissao.ler_avisos" justify="center">
        <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="12">
        <h1>AVISOS IMPORTANTES</h1>
        <el-carousel trigger="click" arrow="always" height="500px">
            <el-carousel-item v-for="item in itens" :key="item.id">
              <h3>{{item.titulo}}</h3>
              <p>{{item.descricao}}</p>
            </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

    <ComponenteLoginSgeClienteFabricante ref = "fabricante"/>

  </div>
</template>

<script>

import axios from 'axios';
import FuncoesUteis from "../plugins/FuncoesUteis";

import ComponenteLoginSgeClienteFabricante from "./ComponenteLoginSgeClienteFabricante.vue";

// const url = 'http://'+window.location.hostname+':8000/api';
const url = '/api';

export default {
  components: {
    ComponenteLoginSgeClienteFabricante,
  },
  data(){
    return {
      loading: true,
      sgeCliente: 0,
      listClientes: [],
      itens: [],
      permissao: {}, 
    }
  },
  mounted(){
    this.permissao = FuncoesUteis.isPermissao();

    if (this.permissao.ler_avisos) {
      this.lerAvisos()
    }
    if (!localStorage.getItem('fabricante_nome')) {
      // console.log('Aqui 1')
      // if (localStorage.getItem('fabricante_qtde') < 2) {
      //   console.log('Aqui 2')
      //   const fabricante = 295;
      //   this.$refs.fabricante.selecionarClienteFabricante(1, fabricante)
      // } else {
      //   console.log('Aqui 3')
        this.$refs.fabricante.definirClienteSgeAdministrador()
      // }
    }
  },
  methods: {
    lerAvisos() {
      axios
        .get(url+'/showavisos/')
        .then(response => {this.itens = response.data;})
        .catch(err => {
              this.itens ='erro'+err;
        });
    },
  }
}
</script>

<style >
.el-carousel__item h3 {
    color: #475669;
    font-size: 30px;
    margin: 0;
    margin-top: 30px;;
  }
.el-carousel__item p {
    color: #475669;
    font-size: 20px;
    margin:10px 55px 0px 55px;
  }  

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
    color:#fff;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
    color: #475669;
  }
</style>